export var EquipmentAvailabilityContent;
(function (EquipmentAvailabilityContent) {
    EquipmentAvailabilityContent["DuplicationOfEquipment"] = "Duplication of equipment";
    EquipmentAvailabilityContent["AtSeaMaintenance"] = "At-sea maintenance";
    EquipmentAvailabilityContent["ShoreBasedMaintenance"] = "Shore-based maintenance";
})(EquipmentAvailabilityContent || (EquipmentAvailabilityContent = {}));
//# sourceMappingURL=EquipmentAvailabilityContent.js.map